import request from './request.js'
import qs from 'qs'
import apilist from './api_list.js'

/**
 *
 * @param {*} url 接口地址
 * @param {*} params 接口参数
 * get接口
 * @returns
 */
function api(url, params) {
  const obj = {
    url: apilist[url].url,
    method: apilist[url].method
  }

  if (['get', 'delete'].includes(obj.method)) {
    obj['params'] = params
  } else if (['post', 'patch', 'put'].includes(obj.method)) {
    obj['data'] = qs.stringify(params)
  }

  return request(obj)
}
export default {
  api
}
